import { get, post, put, patch, del } from '../http/http';
// 访问策略
export default {
    getList: (val) => get('/ip-policy', val), // 查询列表
    addList: (val) => post('/ip-policy', val), // 添加
    delList: (val) => del(`/ip-policy/${val}`), // 删除
    getInfo: (val) => get(`/ip-policy/${val}`), // 详情
    putList: (val) => put(`/ip-policy/${val.id}`, val), // 编辑
    getApiList: (id, val) => get(`/ip-policy/${id}/apis`, val), // 获取查询已绑定API列表
    bindApis: (id, val) => post(`/ip-policy/${id}/apis`, val), // 批量绑定API
    unbindApi: (val) => del(`/ip-policy/${val.id}/api/${val.boundId}`), // 移除api
    getIpList: (id, val) => get(`/ip-policy/${id}/addr`, val), // 获取IP列表
    unbindIp: (val) => del(`/ip-policy/${val.id}/addr/${val.boundId}`), // 移除IP
    changeBind: (appId, id, val) => put(`/ip-policy/${appId}/addr/${id}`, val), // 绑定
    unbind: (val) => del(`/ip-policy/${val.id}/addr/${val.app_id}`), // 解绑
    addApiList: (id, val) => post(`/ip-policy/${id}/api`, val), //添加Api列表
    addIpList: (id, val) => post(`/ip-policy/${id}/addr`, val) //添加Ip列表
}